
import "../../../config";
import {Component, Prop, VModel, Vue} from "vue-property-decorator";
import {getRequiredDocumentCategory, updateDocumentCategory,} from "@pazion/pazion-core/src/services/auth-service";
import {IRequiredDocumentCategory} from "@pazion/pazion-core/src/models/dossier.model";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import PazLoader from "@pazion/pazion-core/src/components/utils/PazLoader.vue";

@Component({
  components: {
    PazTooltipButton,
    PazLoader,
  },
})
export default class EditCategoryDialog extends Vue {
  $refs!: {
    dialogForm: HTMLElement;
  };
  @VModel({
    default: false,
  })
  public showDialog!: boolean;

  @Prop({default: []})
  public masks!: Array<String>;

  @Prop({default: null}) id!: number | null;
  public loading: boolean = false;

  public feedback: string = "";
  public name: string = "";
  public description: string = "";
  public statusMask?: string = "";
  public sortindex: number = 0;


  created() {
    this.loading = true;
  }

  async handleSubmit() {

    this.loading = true;
    const entityId = (this.id && this.id) || 0;
    let formData: any = {
      name: this.name,
      description: this.description,
      statusMask: this.statusMask,
      sortindex: this.sortindex
    };
    const rsp = await updateDocumentCategory(entityId, formData);

    if (rsp.id && (rsp.id == this.id || (this.id == 0 && rsp.id > 0))) {
      this.$emit('onSave')
      this.showDialog = false;
      this.loading = false;
    } else {
      if (rsp && !rsp && rsp.hasOwnProperty("message")) {
        this.feedback = rsp.message;
      } else {
        this.feedback = "Unknown error, see the logs";
      }
      this.loading = false;
    }
  }

  mounted() {
    this.fetchData();
  }


  setData(obj: IRequiredDocumentCategory) {
    this.description = obj.description ?? '';
    this.id = obj.id ?? 0;
    this.name = obj.name;
    this.sortindex = obj.sortindex;
    this.statusMask = obj.statusMask;
  }

  async fetchData() {
    if (this.id) {
      const rsp = await getRequiredDocumentCategory(undefined, this.id);
      if (rsp) {
        this.setData(<IRequiredDocumentCategory>rsp);
      }
    }
    this.loading = false;
  }

  get isLoading() {
    return this.loading;
  }

}
